<template>
  <div class="upload__analyze" @click.stop>
     <!-- newFlag:{{ newFlag }},isAutoAnalyze:{{ isAutoAnalyze }},cacheFile:{{ cacheFile }} -->
    <el-tooltip 
      v-if="newFlag && isAutoAnalyze && !cacheFile"  
      effect="dark" 
      content="为确保信息无误，请核对后下单" 
      placement="top">
      <div class="analyze-coord">
        自动解析
      </div>
    </el-tooltip>
    <i v-else class="el-icon-success"></i>
    <div class="upload__analyze__name">
      <p>
        {{ name }}
      </p>
    </div>
    <div class="upload__analyze__btns">
      <BaseTextButton  v-if="newFlag && isAutoAnalyze && !cacheFile"  :plain="false" @click="handleClick">
        手动上传
      </BaseTextButton>
      <BaseTextButton v-else :plain="false" @click="handleClick">
        重新上传
      </BaseTextButton>
      <template v-if="newFlag ">
        <template v-if="!isAutoAnalyze">
          <span 
            ref="uploadHandleRef" 
            class="upload_handle" 
            v-if="cacheFile && cacheFile.coordPath" 
            @click="handleUseCachedAnalysis">
            使用自动解析文件
          </span>
        </template>
        <span 
          ref="uploadHandleRef" 
          class="upload_handle" 
          v-else  
          @click="downLoadFile">
          <i class="icon-download"></i>
          下载解析文件
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnalyzeResult',
  props: {
    newFlag: {
      type: Boolean,
      default: false
    },
    isAutoAnalyze: {
      type: Boolean,
      default: false
    },
    cacheFile: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String,
      default: ''
    },
    fileUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick() {
      this.$emit('retry');
    },
    handleUseCachedAnalysis() {
      this.$emit('use-cached-analysis', this.cacheFile);
    },
    downLoadFile() {
      window.open(this.fileUrl);
    }
  }
}
</script>

<style lang="scss" scoped>
.upload__analyze__btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.icon-download{
  width: 16px;
  height: 16px;
  background: url(~@@/assets/img/icons/downLoad.png) no-repeat center center;
  background-size:contain ;
}
.upload_handle {
  display: flex;
  align-items: center;
  color: #15A675;
}

.upload__analyze {
  text-align: left;
  >i {
    position: absolute;
    top: -6px;
    right: -6px;
    font-size: 18px;
    color: #67C23A;
  }
  
  .analyze-coord {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 12px;
    padding: 2px 4px;
    background: #68C33A;
    color: #fff;
    border-radius: 0px 4px 0px 4px;
    line-height: 1;
  }
  
  .upload__analyze__name {
    display: flex;
    align-items: center;
    margin-bottom: 7px;
    height: 40px;
    
    >p {
      line-height: 20px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}
</style>